/**
 * Nút chọn giao diện: Theo hệ thống / Sáng / Tối.
 * Đổi có hiệu lực ngay, không cần tải lại trang.
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';

import { THEME_LABELS, THEME_MODES } from './theme-storage';
import { useThemeMode } from './theme-provider';

const ICONS = { system: faDesktop, light: faSun, dark: faMoon };

export default function ThemeToggle({ className = '' }) {
    const { mode, setMode } = useThemeMode();

    return (
        <div
            className={`flex items-center gap-1 rounded-full border border-line bg-surface-muted p-1 ${className}`}
            role="radiogroup"
            aria-label="Chế độ giao diện"
        >
            {THEME_MODES.map((option) => {
                const selected = option === mode;
                return (
                    <button
                        key={option}
                        type="button"
                        role="radio"
                        aria-checked={selected}
                        title={THEME_LABELS[option]}
                        aria-label={THEME_LABELS[option]}
                        onClick={() => setMode(option)}
                        className={`flex h-7 w-7 items-center justify-center rounded-full transition-colors ${
                            selected
                                ? 'bg-surface text-brand2 shadow-sm'
                                : 'text-content-3 hover:text-content-2'
                        }`}
                    >
                        <FontAwesomeIcon icon={ICONS[option]} className="text-xs" />
                    </button>
                );
            })}
        </div>
    );
}
